import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { generateResponseScheme, type RespondedType, type RespondedWith, type ResponseError } from '@/models/response';
import { type CreatedTag, createdTagScheme } from '@/models/user/tag';
import { addToast, addTranslateToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

import { tagListQueryOptions } from './use-tags';

export default function useCreateTag() {
  const queryClient = useQueryClient();

  return useMutation<RespondedWith<CreatedTag>, ResponseError, string>({
    mutationFn: (tagName) =>
      fetcher<RespondedType>(
        '/CreateTag',
        { TagName: tagName },
        { schema: generateResponseScheme(createdTagScheme), validResponseCodes: [0] },
      ),
    onSuccess: (data) => {
      addTranslateToast({
        type: 'success',
        message: 'common.add-success',
      });

      queryClient.setQueryData(tagListQueryOptions.queryKey, (state) =>
        produce(state, (draft) => {
          if (draft && data.Data) {
            draft.unshift({
              TagCount: 0,
              TagName: data.Data.Name,
              Id: data.Data.Id,
              TagMember: [],
            });
            draft.sort((a, b) => b.Id - a.Id);
          }

          return draft;
        }),
      );
    },
    onError: (error) => {
      addToast({
        type: 'error',
        message: error.message,
      });
    },
  });
}
